namespace RioERP.Carts {
    export interface CounterProductsForm {
        ProductName: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        SkuCode: Serenity.StringEditor;
        EProductType: Serenity.IntegerEditor;
        ERioplayVersion: Serenity.IntegerEditor;
        RioplayProductCode: Serenity.StringEditor;
        DownloadUrl1: Serenity.StringEditor;
        DownloadUrl2: Serenity.StringEditor;
        HasPenDrive: Serenity.BooleanEditor;
        HasBooks: Serenity.BooleanEditor;
        HasCourier: Serenity.BooleanEditor;
        Note: Serenity.StringEditor;
        Weight: Serenity.DecimalEditor;
        Height: Serenity.DecimalEditor;
        Width: Serenity.DecimalEditor;
        Length: Serenity.DecimalEditor;
        EPackingType: Serenity.IntegerEditor;
        GrossAmount: Serenity.DecimalEditor;
        EOpens: Serenity.IntegerEditor;
        EWatchTime: Serenity.IntegerEditor;
        EValidity: Serenity.IntegerEditor;
        EValidityType: Serenity.IntegerEditor;
        ValidTill: Serenity.DateEditor;
        TotalAllowedDuration: Serenity.IntegerEditor;
        AllowSerialKeyGeneration: Serenity.BooleanEditor;
        AllowedDevices: Serenity.StringEditor;
        IsLive: Serenity.BooleanEditor;
        ProcesOrderOnPaid: Serenity.BooleanEditor;
        EAccessStatus: Serenity.IntegerEditor;
        InAppDownload: Serenity.BooleanEditor;
        HasVod: Serenity.BooleanEditor;
        TemplateSerialKeyId: Serenity.IntegerEditor;
        IsActive: Serenity.BooleanEditor;
        InsertUserId: Serenity.IntegerEditor;
        InsertDate: Serenity.DateEditor;
        UpdateUserId: Serenity.IntegerEditor;
        UpdateDate: Serenity.DateEditor;
        VendorId: Serenity.IntegerEditor;
        SupportInfo: Serenity.StringEditor;
        ProductQueryInfo: Serenity.StringEditor;
        EShippedby: Serenity.IntegerEditor;
        ActivateSerialKey: Serenity.BooleanEditor;
        IsCombo: Serenity.BooleanEditor;
        ProductIds: Serenity.StringEditor;
        WebsiteUrl: Serenity.StringEditor;
        TeacherName: Serenity.StringEditor;
        RioPlayTenantId: Serenity.IntegerEditor;
        Secretkey: Serenity.StringEditor;
        Thumbnail: Serenity.StringEditor;
    }

    export class CounterProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Carts.CounterProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CounterProductsForm.init)  {
                CounterProductsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.BooleanEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(CounterProductsForm, [
                    'ProductName', w0,
                    'Description', w0,
                    'SkuCode', w0,
                    'EProductType', w1,
                    'ERioplayVersion', w1,
                    'RioplayProductCode', w0,
                    'DownloadUrl1', w0,
                    'DownloadUrl2', w0,
                    'HasPenDrive', w2,
                    'HasBooks', w2,
                    'HasCourier', w2,
                    'Note', w0,
                    'Weight', w3,
                    'Height', w3,
                    'Width', w3,
                    'Length', w3,
                    'EPackingType', w1,
                    'GrossAmount', w3,
                    'EOpens', w1,
                    'EWatchTime', w1,
                    'EValidity', w1,
                    'EValidityType', w1,
                    'ValidTill', w4,
                    'TotalAllowedDuration', w1,
                    'AllowSerialKeyGeneration', w2,
                    'AllowedDevices', w0,
                    'IsLive', w2,
                    'ProcesOrderOnPaid', w2,
                    'EAccessStatus', w1,
                    'InAppDownload', w2,
                    'HasVod', w2,
                    'TemplateSerialKeyId', w1,
                    'IsActive', w2,
                    'InsertUserId', w1,
                    'InsertDate', w4,
                    'UpdateUserId', w1,
                    'UpdateDate', w4,
                    'VendorId', w1,
                    'SupportInfo', w0,
                    'ProductQueryInfo', w0,
                    'EShippedby', w1,
                    'ActivateSerialKey', w2,
                    'IsCombo', w2,
                    'ProductIds', w0,
                    'WebsiteUrl', w0,
                    'TeacherName', w0,
                    'RioPlayTenantId', w1,
                    'Secretkey', w0,
                    'Thumbnail', w0
                ]);
            }
        }
    }
}
